module.exports = __webpack_public_path__ + "templates-59e97cd7/template-4-2x-50b4ae1e9a1812538942af577a9ad05b.jpg";